module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARBAMAAADalBo9AAAALVBMVEUAAAD/aZb/aY/6aZH8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY/8aY/8aY/fKVvMAAAADnRSTlMAESIzVWZ3iJmqu8zd7srP4mIAAACQSURBVAjXY2CcvRsGJjIwSL+G814LMOQ5MMCAXwJDXQKcl1fAUNchAOVI9AF5ooshHOalckCegBZEbZYCmMcAVivRwADhRQHVMq8KgPA4GoFqsxQ7wDyhZQwMnZ4NDGyLQLwoAwYGlhKgTqs4IK8RZjkjyD4DuFvsChh0j5fDwFkFBpZz72DgCEi5IAwwMAAAX2o9F8lEyPcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/send.png
// module id = 684
// module chunks = 0